import LazyLoad from 'vanilla-lazyload'

class Lazy {
    constructor() {
        this.lazy = new LazyLoad()
    }
}

export default Lazy
